import { memo } from "react";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import { useActionContext } from "../../providers";

const Reject = () => {
    const { reject } = useActionContext();

    return (
        <ListItem
            disablePadding
        >
            <ListItemButton
                onPointerDown={reject}
            >
                <ListItemIcon>
                    <ThumbDownIcon
                        color='error'
                    />
                </ListItemIcon>
                <ListItemText
                    sx={{
                        color: 'error.main'
                    }}
                    primary='Reject'
                />
            </ListItemButton>
        </ListItem>
    );
};

export default memo(Reject);
